import React, { Component } from 'react';
import { Label, utils } from 'react-bootstrap';
import SeverityLabel from '../../../../components/SeverityLabel/SeverityLabel';

const severities = [
    {
        code: 'GREEN',
        meaning: '> 2 hrs of YST remaining',
    },
    {
        code: 'YELLOW',
        meaning: '< 2 hrs of YST remaining',
    },
    {
        code: 'ORANGE',
        meaning: 'Miss Standard Unloading (TIP) Time or Tap Time',
    },
    {
        code: 'RED',
        meaning: 'Miss P-Lane Exit or Connection Time at CD/CP',
    },
];
utils.bootstrapUtils.addStyle(Label, 'custom');

class DelayLegend extends Component {
    render() {
        return (
            <div style={{ marginTop: 24, marginBottom: 24 }}>
                <p
                    style={{
                        textAlign: 'center',
                        margin: 0,
                        lineHeight: '2em',
                    }}
                >
                    <span style={{ fontWeight: 'bold' }}>Severity:</span>
                    {severities.map(severity => (
                        <span key={severity.code} style={{ marginLeft: 25 }}>
                            <SeverityLabel code={severity.code} style={{ marginRight: 5 }} />
                            {severity.meaning}
                        </span>
                    ))}
                </p>
            </div>
        );
    }
}

export default DelayLegend;
